module.exports = __webpack_public_path__ + "static/media/400152_01.1e75f972.png";